module.exports = __webpack_public_path__ + "static/img/1.cc55d15.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/1.png
// module id = jleR
// module chunks = 0